import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function ActivationCallback() {
  const [params] = useSearchParams();

  useEffect(() => {
    const status = params.get("status");

    if (status === "200") {
      alert("Subscription Successful ✅");
    } else {
      alert("Subscription Failed ❌");
    }
  }, []);

  return <h2>Processing...</h2>;
}